/**
 * Builds an attribute selector with a safely quoted value.
 *
 * Deliberately not `CSS.escape`: the `CSS` global is absent from some embedded
 * webviews (and from jsdom), and all we need is to survive a quote or backslash
 * inside a list key.
 */
export function attrSelector(name: string, value: string): string {
  return `[${name}="${value.replace(/\\/g, "\\\\").replace(/"/g, '\\"')}"]`;
}

export const DEBOUNCE_MS = 300;

export function debounce<T extends (...args: never[]) => void>(fn: T, ms: number): T {
  let timer: number | undefined;
  return ((...args: never[]) => {
    window.clearTimeout(timer);
    timer = window.setTimeout(() => fn(...args), ms);
  }) as T;
}
